// extracted by mini-css-extract-plugin
export default {"roleSwitcher":"RoleSwitcher_roleSwitcher__g2DRz","caption":"RoleSwitcher_caption__eNOZw"};